__turbopack_context__.v({
  "contentAnimation": "aboutContentSection-module__VPVY-W__contentAnimation",
  "fadeInUp": "aboutContentSection-module__VPVY-W__fadeInUp",
  "headingAnimation": "aboutContentSection-module__VPVY-W__headingAnimation",
  "sectionAnimation": "aboutContentSection-module__VPVY-W__sectionAnimation",
});
